import { put } from 'redux-saga/effects';

import api from '../../helpers/api';
import { getCompanyFromWebSessionStorage } from '../../helpers/session';
import { ReduxState } from '../../types/redux/state';
import { ProjectsStoreItem } from '../../types/redux/stores/projects.types';
import { selectShowCustomer, selectToken, selectUserId } from '../selectors';
import { store } from '../store';
import * as actions from './actions';
import { shouldFetchProjectsOfClient } from './utils';

export function* getProjectsRequestSaga(): Generator<any, void, any> {
  try {
    const _store: ReduxState = store.getState();
    const userId = selectUserId(_store);
    const companyId = (yield getCompanyFromWebSessionStorage())?.id;
    const res = yield api.send({
      url: '/projects',
      method: 'GET',
      cache: 'default',
      params: {
        userId,
        companyId,
      },
      token: selectToken(_store),
    });
    yield put(actions.getProjectsRequestSuccess({ res }));
  } catch (error) {
    yield put(actions.getProjectsRequestFailure(error));
  }
}

export function* getProjectsOfClientRequestSaga({
  payload,
}: ReturnType<typeof actions.getProjectsOfClientRequest>): Generator<any, void, any> {
  const clientId = payload.clientId;
  try {
    const _store: ReduxState = store.getState();
    const companyId = (yield getCompanyFromWebSessionStorage())?.id;
    const userId = selectUserId(_store);
    const showCustomer = selectShowCustomer(_store);
    if (!shouldFetchProjectsOfClient(_store.projects, clientId, showCustomer)) {
      yield put(actions.getProjectsOfClientStopLoading({ clientId: clientId }));
      return;
    }
    const res: ProjectsStoreItem[] = yield api.send({
      url: '/projects',
      method: 'GET',
      cache: 'default',
      token: selectToken(_store),
      params: {
        ...payload,
        companyId,
        userId,
        clientId: showCustomer ? (clientId === 'all' || !clientId ? '' : clientId) : undefined,
      },
    });
    yield put(
      actions.getProjectsOfClientRequestSuccess({
        res,
        payloadData: payload,
      }),
    );
  } catch (error) {
    yield put(actions.getProjectsOfClientRequestFailure({ error, clientId: clientId }));
  }
}
